import { useIsMinTabletSize } from "../../hooks/useMediaQuery";
import {
  Pagination as MUIPagination,
  PaginationItem as MUIPaginationItem,
  type PaginationProps,
  type PaginationRenderItemParams,
} from "@mui/material";
import { C_ON_SURFACE, C_PRIMARY, C_PRIMARY_DISABLED, C_PRIMARY_HOVER, C_SECONDARY_HOVER } from "../icon/Colors";
import { makeStyles, withStyles } from "@mui/styles";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

const usePaginationStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
  },
});

export type MUIPaginationProps = PaginationProps;

export const Pagination = (props: PaginationProps) => {
  const isTablet = useIsMinTabletSize();
  const classes = usePaginationStyles(props);

  const siblingCount = isTablet ? 1 : 0;

  return <MUIPagination siblingCount={siblingCount} renderItem={defaultRenderItem} {...props} classes={classes} />;
};

export const defaultRenderItem = (props: PaginationRenderItemParams) => <PaginationItem {...props} />;

export const PaginationItem = withStyles({
  root: {
    ...getFontStyle(FontSize.BodyMedium),
    lineHeight: "36px", // Match the height for nice alignment
    width: "36px",
    height: "36px",
    margin: 0,
    color: C_ON_SURFACE,
    "&:hover": {
      color: C_SECONDARY_HOVER,
    },
  },
  icon: {
    fontSize: "24px",
    color: C_PRIMARY,
    "&:hover": {
      color: C_PRIMARY_HOVER,
    },
  },
  selected: {
    color: C_PRIMARY,
    "&:hover": {
      color: C_PRIMARY_HOVER,
    },
    background: "none",
  },
  disabled: {
    opacity: 1,
    color: C_PRIMARY_DISABLED,
  },
})(MUIPaginationItem);
